import { render, staticRenderFns } from "./ChevronRightLight.vue?vue&type=template&id=aab85d1a"
import script from "./ChevronRightLight.vue?vue&type=script&lang=ts"
export * from "./ChevronRightLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports